var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"score"},_vm._l((5),function(star){return _c('div',{staticClass:"score-star",class:_vm.value >= star ? 'score-active' : '',domProps:{"innerHTML":_vm._s(_vm.svg)},on:{"click":function($event){_vm.model = star}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }